import React from 'react';

// SVG Component for X
export const XIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <line x1="20" y1="20" x2="80" y2="80" stroke="#e74c3c" strokeWidth="8" strokeLinecap="round"/>
    <line x1="80" y1="20" x2="20" y2="80" stroke="#e74c3c" strokeWidth="8" strokeLinecap="round"/>
  </svg>
);

// SVG Component for O
export const OIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="30" stroke="#3498db" strokeWidth="8" fill="none"/>
  </svg>
);

// SVG Component for Dog
export const DogIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    {/* Dog head */}
    <ellipse cx="50" cy="55" rx="20" ry="25" fill="#8B4513"/>
    {/* Left ear */}
    <ellipse cx="35" cy="35" rx="8" ry="15" fill="#8B4513"/>
    {/* Right ear */}
    <ellipse cx="65" cy="35" rx="8" ry="15" fill="#8B4513"/>
    {/* Left eye */}
    <circle cx="43" cy="50" r="3" fill="#000"/>
    {/* Right eye */}
    <circle cx="57" cy="50" r="3" fill="#000"/>
    {/* Nose */}
    <circle cx="50" cy="62" r="4" fill="#000"/>
    {/* Mouth */}
    <path d="M 50 66 Q 45 70 40 68" stroke="#000" strokeWidth="2" fill="none"/>
    <path d="M 50 66 Q 55 70 60 68" stroke="#000" strokeWidth="2" fill="none"/>
  </svg>
);

// SVG Component for Cat
export const CatIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    {/* Cat head */}
    <circle cx="50" cy="55" r="22" fill="#FF8C00"/>
    {/* Left ear */}
    <path d="M 35 40 L 28 20 L 42 35 Z" fill="#FF8C00"/>
    {/* Right ear */}
    <path d="M 65 40 L 72 20 L 58 35 Z" fill="#FF8C00"/>
    {/* Left eye */}
    <ellipse cx="42" cy="52" rx="3" ry="5" fill="#000"/>
    {/* Right eye */}
    <ellipse cx="58" cy="52" rx="3" ry="5" fill="#000"/>
    {/* Nose */}
    <path d="M 50 60 L 47 63 L 53 63 Z" fill="#FF69B4"/>
    {/* Whiskers - left */}
    <line x1="30" y1="55" x2="40" y2="54" stroke="#000" strokeWidth="1"/>
    <line x1="30" y1="58" x2="40" y2="58" stroke="#000" strokeWidth="1"/>
    {/* Whiskers - right */}
    <line x1="70" y1="55" x2="60" y2="54" stroke="#000" strokeWidth="1"/>
    <line x1="70" y1="58" x2="60" y2="58" stroke="#000" strokeWidth="1"/>
  </svg>
);

// SVG Components for Traffic Lights
export const GreenCircle = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#4CAF50"/>
  </svg>
);

export const YellowCircle = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#FFC107"/>
  </svg>
);

export const RedCircle = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#F44336"/>
  </svg>
);

// SVG Components for Hex Game
export const RedHexPiece = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="40" fill="#dc143c"/>
  </svg>
);

export const BlueHexPiece = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="40" fill="#000080"/>
  </svg>
);

// SVG Components for Checkers Game
export const RedChecker = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#dc143c" stroke="#8b0000" strokeWidth="3"/>
    <circle cx="50" cy="50" r="30" fill="#ff6b6b" opacity="0.6"/>
  </svg>
);

export const BlackChecker = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#2c2c2c" stroke="#000000" strokeWidth="3"/>
    <circle cx="50" cy="50" r="30" fill="#555555" opacity="0.6"/>
  </svg>
);

export const RedKing = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#dc143c" stroke="#8b0000" strokeWidth="3"/>
    <circle cx="50" cy="50" r="30" fill="#ff6b6b" opacity="0.6"/>
    {/* Crown */}
    <path d="M 35 40 L 40 50 L 45 40 L 50 50 L 55 40 L 60 50 L 65 40 L 65 60 L 35 60 Z" fill="#FFD700" stroke="#DAA520" strokeWidth="1.5"/>
  </svg>
);

export const BlackKing = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill="#2c2c2c" stroke="#000000" strokeWidth="3"/>
    <circle cx="50" cy="50" r="30" fill="#555555" opacity="0.6"/>
    {/* Crown */}
    <path d="M 35 40 L 40 50 L 45 40 L 50 50 L 55 40 L 60 50 L 65 40 L 65 60 L 35 60 Z" fill="#FFD700" stroke="#DAA520" strokeWidth="1.5"/>
  </svg>
);

// Nine Men's Morris Board
export const NineMensMorrisBoard = ({ onPositionClick, board, validMoves = [] }) => {
  // Board positions (24 positions on the board)
  // Outer square: 0-7, Middle square: 8-15, Inner square: 16-23
  const positions = [
    // Outer square
    { x: 50, y: 50 },    // 0 - top left
    { x: 350, y: 50 },   // 1 - top middle
    { x: 650, y: 50 },   // 2 - top right
    { x: 650, y: 350 },  // 3 - middle right
    { x: 650, y: 650 },  // 4 - bottom right
    { x: 350, y: 650 },  // 5 - bottom middle
    { x: 50, y: 650 },   // 6 - bottom left
    { x: 50, y: 350 },   // 7 - middle left
    // Middle square
    { x: 150, y: 150 },  // 8 - top left
    { x: 350, y: 150 },  // 9 - top middle
    { x: 550, y: 150 },  // 10 - top right
    { x: 550, y: 350 },  // 11 - middle right
    { x: 550, y: 550 },  // 12 - bottom right
    { x: 350, y: 550 },  // 13 - bottom middle
    { x: 150, y: 550 },  // 14 - bottom left
    { x: 150, y: 350 },  // 15 - middle left
    // Inner square
    { x: 250, y: 250 },  // 16 - top left
    { x: 350, y: 250 },  // 17 - top middle
    { x: 450, y: 250 },  // 18 - top right
    { x: 450, y: 350 },  // 19 - middle right
    { x: 450, y: 450 },  // 20 - bottom right
    { x: 350, y: 450 },  // 21 - bottom middle
    { x: 250, y: 450 },  // 22 - bottom left
    { x: 250, y: 350 }   // 23 - middle left
  ];

  // Define connections (adjacency list)
  const connections = [
    [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 7], [7, 0], // Outer square
    [8, 9], [9, 10], [10, 11], [11, 12], [12, 13], [13, 14], [14, 15], [15, 8], // Middle square
    [16, 17], [17, 18], [18, 19], [19, 20], [20, 21], [21, 22], [22, 23], [23, 16], // Inner square
    [1, 9], [9, 17], // Top middle connections
    [3, 11], [11, 19], // Right middle connections
    [5, 13], [13, 21], // Bottom middle connections
    [7, 15], [15, 23]  // Left middle connections
  ];

  return (
    <svg viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" style={{ maxWidth: '600px', margin: '20px auto' }}>
      {/* Board background */}
      <rect x="0" y="0" width="700" height="700" fill="#d4a574" />
      
      {/* Draw connection lines */}
      {connections.map(([from, to], idx) => (
        <line
          key={idx}
          x1={positions[from].x}
          y1={positions[from].y}
          x2={positions[to].x}
          y2={positions[to].y}
          stroke="#2c1810"
          strokeWidth="3"
        />
      ))}

      {/* Draw positions and pieces */}
      {positions.map((pos, idx) => {
        const piece = board[idx];
        const isValidMove = validMoves.includes(idx);
        
        return (
          <g key={idx}>
            {/* Position circle (clickable area) */}
            <circle
              cx={pos.x}
              cy={pos.y}
              r="20"
              fill={isValidMove ? '#90EE90' : '#f5deb3'}
              stroke="#2c1810"
              strokeWidth="2"
              style={{ cursor: 'pointer' }}
              onClick={() => onPositionClick(idx)}
            />
            
            {/* Piece if present */}
            {piece && (
              <g transform={`translate(${pos.x - 30}, ${pos.y - 30})`}>
                {piece === 1 ? (
                  <>
                    <circle cx="30" cy="30" r="24" fill="#f5f5f5" stroke="#333" strokeWidth="2"/>
                    <circle cx="30" cy="30" r="20" fill="#ffffff" opacity="0.7"/>
                  </>
                ) : (
                  <>
                    <circle cx="30" cy="30" r="24" fill="#1a1a1a" stroke="#000" strokeWidth="2"/>
                    <circle cx="30" cy="30" r="20" fill="#3a3a3a" opacity="0.6"/>
                  </>
                )}
              </g>
            )}
          </g>
        );
      })}
    </svg>
  );
};
